import React, { memo } from 'react';
import { Column } from 'components/Layout/Grid';
import Input from 'components/Input';

const Validator: React.FC<any> = (props) => {
  const {
    children,
    stateName,
    value,
    required,
    name,
    minLength
  } = props;

  return (
    <Column className='mb-1'>
      {children}
      <Input
        stateName={stateName || undefined}
        className="d-none"
        type="text"
        value={value}
        onChange={() => { }}
        required={required}
        name={name}
        minLength={minLength}
      />
    </Column>
  );
};

export default memo(Validator);
